import _pt from "prop-types";
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import React, { useMemo } from 'react';
import DialogBase from '../DialogBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriDialog'
};

const styles = theme => ({
  root: {
    gridTemplateAreas: `
    ". header ."
    "content content content"
  `,
    gridTemplateColumns: '1fr auto 1fr',
    gridTemplateRows: 'auto 1fr',
    justifyItems: 'stretch',
    [theme.breakpoints.between('xs', 390)]: {
      minWidth: '280px'
    }
  },
  header: {
    gridArea: 'header'
  },
  content: {
    gridArea: 'content'
  }
});

export const Dialog = props => {
  const {
    header,
    children,
    classes,
    open,
    ...dialogBaseProps
  } = props;
  const headerComponent = useMemo(() => {
    if (typeof header === 'string') return /*#__PURE__*/_jsx(Typography, {
      gutterBottom: true,
      variant: "h4",
      children: header
    });
    return header;
  }, [header]);
  return /*#__PURE__*/_jsxs(DialogBase, {
    classes: {
      dialogGrid: classes.root
    },
    open: open,
    ...dialogBaseProps,
    children: [header && /*#__PURE__*/_jsx("div", {
      className: classes.header,
      children: headerComponent
    }), children && /*#__PURE__*/_jsx("div", {
      className: classes.content,
      children: children
    })]
  });
};
export default withStyles(styles, componentConfig)(Dialog);